import { useState } from 'react';
import { CustomButton } from '../../../../components/CustomButton';
import { CustomInput } from '../../../../components/CustomInput';
import RModal from '../../../../components/Rsuite/Modal';
import { Label } from '../../../../components/Label';
import api from '../../../../services/api';
import { useAuth } from '../../../../hooks/auth';
import { toastSuccess, toastError } from '../../../../toasts';
import { useAlert } from '../../../../contexts/Alert.context';

export function CopyCompany({ open, onClose }) {
  const [contractOrigin, setContractOrigin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { id_empresa } = useAuth();
  const { showAlert } = useAlert();

  const handleCopyCompany = async () => {
    try {
      setIsLoading(true);

      if (!contractOrigin) {
        throw new Error('Campo obrigatório vazio');
      }

      const requestData = {
        contractNumber: id_empresa,
        cloneContractNumber: contractOrigin,
      };

      await api.post('clone-company', requestData);

      toastSuccess('Dados da unidade importados com sucesso!');
      onClose();
    } catch (error) {
      console.log({ error });
      const statusCode = error?.response?.data?.statusCode;
      const message =
        statusCode === 400
          ? 'Número de contrato inválido ou não encontrado.'
          : 'Não foi possível realizar a importação no momento. Tente novamente.';

      toastError(message);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmCopyCompany = () => {
    showAlert({
      title: 'Atenção: Importação de Dados',
      text: `Você está prestes a importar as configurações do contrato nº ${contractOrigin} para esta unidade. Tem certeza que deseja continuar?`,
      onSubmit: handleCopyCompany,
    });
  };

  return (
    <RModal
      title="Importar dados de outra unidade"
      open={open}
      onClose={onClose}
      bodyWidth="450px"
      footer={
        <>
          <CustomButton appearance="default" onClick={onClose} disabled={isLoading}>
            Cancelar
          </CustomButton>
          <CustomButton
            appearance="primary"
            onClick={confirmCopyCompany}
            disabled={!contractOrigin || isLoading}
            loading={isLoading}
          >
            Importar Dados
          </CustomButton>
        </>
      }
    >
      <div style={{
        marginBottom: '20px',
        padding: '12px',
        backgroundColor: '#f0f4f8',
        borderRadius: '8px',
        color: '#4a5568',
        fontSize: '14px',
        lineHeight: '1.5'
      }}>
        <strong>Como funciona?</strong> <br />
        Use esta ferramenta para copiar configurações e cadastros base de um estabelecimento já existente para o seu atual.
        Para isso, digite o número do contrato do estabelecimento de origem.
      </div>

      <Label>Número do Contrato de Origem</Label>
      <CustomInput
        value={contractOrigin}
        placeholder="Ex: 1234"
        onChange={setContractOrigin}
        type="number"
      />
    </RModal>
  );
}
